import jsPDF from 'jspdf';
import { TrafficTicket } from '../types';

export class ReceiptService {
  static generateReceiptPDF(ticket: TrafficTicket): jsPDF {
    const doc = new jsPDF();
    
    // Set font
    doc.setFont('helvetica');
    
    // Header
    doc.setFontSize(20);
    doc.text('Caribbean Traffic Tickets', 105, 20, { align: 'center' });
    
    doc.setFontSize(14);
    doc.text('Payment Receipt', 105, 30, { align: 'center' });
    
    // Receipt Info
    doc.setFontSize(10);
    doc.text(`Receipt #: ${ticket.ticketCode}-REC-${Date.now()}`, 20, 50);
    doc.text(`Payment Date: ${ticket.paymentDate ? ticket.paymentDate.toLocaleDateString() : new Date().toLocaleDateString()}`, 20, 60);
    doc.text(`Payment Time: ${ticket.paymentDate ? ticket.paymentDate.toLocaleTimeString() : new Date().toLocaleTimeString()}`, 20, 70);
    
    // Line separator
    doc.line(20, 80, 190, 80);
    
    // Ticket Details
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Ticket Details', 20, 95);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`Ticket Code: ${ticket.ticketCode}`, 20, 105);
    doc.text(`Offence Type: ${ticket.offenceType}`, 20, 115);
    doc.text(`Fine Amount: $${(ticket.fineAmount || 0).toFixed(2)} XCD`, 20, 125);
    doc.text(`Status: ${ticket.status.toUpperCase()}`, 20, 135);
    
    // Violator Details
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Violator Details', 20, 155);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`Name: ${ticket.violatorName}`, 20, 165);
    doc.text(`License Number: ${ticket.licenceNumber}`, 20, 175);
    doc.text(`License Plate: ${ticket.licensePlate}`, 20, 185);
    
    // Location Details
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Location Details', 20, 205);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`Address: ${ticket.address}`, 20, 215);
    doc.text(`Parish: ${ticket.parish}`, 20, 225);
    doc.text(`Island: ${ticket.island}`, 20, 235);
    
    // Payment Summary
    doc.line(20, 250, 190, 250);
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Payment Summary', 20, 265);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`Fine Amount: $${(ticket.fineAmount || 0).toFixed(2)} XCD`, 20, 275);
    doc.text(`Payment Method: Credit Card`, 20, 285);
    doc.text(`Transaction ID: ${ticket.id}`, 20, 295);
    
    // Footer
    doc.setFontSize(8);
    doc.text('This is an official receipt for your traffic ticket payment.', 105, 320, { align: 'center' });
    doc.text('Please keep this receipt for your records.', 105, 330, { align: 'center' });
    
    return doc;
  }
  
  static downloadReceipt(ticket: TrafficTicket) {
    const doc = this.generateReceiptPDF(ticket);
    const filename = `receipt-${ticket.ticketCode}-${Date.now()}.pdf`;
    doc.save(filename);
  }
  
  static getReceiptDataURL(ticket: TrafficTicket): string {
    const doc = this.generateReceiptPDF(ticket);
    return doc.output('datauristring');
  }
}
